import React from 'react';
import { Differentiation } from '@zola/zola-ui/src/components/PreAuthV3';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import type { ImageDetails } from '@zola/zola-ui/src/components/PreAuthV3/imgUtils';
import { TABLET_MAX, MOBILE_MAX } from '@zola-helpers/client/dist/es/util/responsive';
import type { DifferentiationProps } from '@zola/zola-ui/src/components/PreAuthV3/Differentiation';

import desktop4 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorDesktop/imgadvisor_spotlight_desktop_01@2x.jpg';
import desktop3 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorDesktop/imgadvisor_spotlight_desktop_02@2x.jpg';
import desktop2 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorDesktop/imgadvisor_spotlight_desktop_03@2x.jpg';
import desktop1 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorDesktop/imgadvisor_spotlight_desktop_04@2x.jpg';

import tablet4 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorTablet/imgadvisor_spotlight_tablet_01@2x.jpg';
import tablet3 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorTablet/imgadvisor_spotlight_tablet_02@2x.jpg';
import tablet2 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorTablet/imgadvisor_spotlight_tablet_03@2x.jpg';
import tablet1 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorTablet/imgadvisor_spotlight_tablet_04@2x.jpg';

// Mobile
import mobile3 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorMobile/imgadvisor_spotlight_mobile_01@2x.jpg';
import mobile4 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorMobile/imgadvisor_spotlight_mobile_02@2x.jpg';
import mobile2 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorMobile/imgadvisor_spotlight_mobile_03@2x.jpg';
import mobile1 from '../../../../public/static-preauth/images/AdvisorLp/AdvisorMobile/imgadvisor_spotlight_mobile_04@2x.jpg';

import { Container } from './AdvisorLpDifferentiation.styles';

type AdvisorLpDifferentiationProps = {
  className?: string;
};

type ResponsiveImageSet = {
  mobile?: string;
  tablet?: string;
  desktop?: string;
};

function imagesToImageDetails({ mobile, tablet, desktop }: ResponsiveImageSet): ImageDetails[] {
  const imageDetails: ImageDetails[] = [];
  if (mobile) {
    imageDetails.push({ url: mobile, breakpoint: MOBILE_MAX.toString() });
  }
  if (tablet) {
    imageDetails.push({ url: tablet, breakpoint: TABLET_MAX.toString() });
  }
  if (desktop) {
    imageDetails.push({ url: desktop, breakpoint: '20000' });
  }
  return imageDetails;
}

const titleProps = {
  titleStart: 'Advisor spotlight:',
  highlightText: "Hi, I'm Ian 👋",
};

const menuItems: DifferentiationProps['content'] = [
  {
    id: 'how-to-find-ian',
    subtitle: 'Where can I find you at Zola?',
    description:
      "You can reach me directly via email, or book a coffee chat. You'll also find me on IG and Tiktok answering questions in our Pop The Questions series, and sharing wedding trends. Follow along or send us a DM!",
    image: {
      background: {
        type: BackgroundType.IMAGE,
        parameters: {
          alt: 'Ian smiling at the camera',
          featuredSrc: mobile1,
          jpg: imagesToImageDetails({ mobile: mobile1, tablet: tablet1, desktop: desktop1 }),
        },
      },
    },
  },
  {
    id: 'favorite-movie',
    subtitle: "What's your favorite wedding movie?",
    description: 'Princess Diaries 2: Royal Engagement',
    image: {
      background: {
        type: BackgroundType.IMAGE,
        parameters: {
          alt: 'Ian smiling and shrugging in a blue floral shirt',
          featuredSrc: mobile2,
          jpg: imagesToImageDetails({ mobile: mobile2, tablet: tablet2, desktop: desktop2 }),
        },
      },
    },
  },
  {
    id: 'favorite-moment',
    subtitle: "What's your favorite moment at a wedding?",
    description:
      'Dancing the night away and when everyone breaks out into song and dance at the end of the night.',
    image: {
      background: {
        type: BackgroundType.IMAGE,
        parameters: {
          alt: 'Someone dancing at a wedding on the dance floor',
          featuredSrc: mobile3,
          jpg: imagesToImageDetails({ mobile: mobile3, tablet: tablet3, desktop: desktop3 }),
        },
      },
    },
  },
  {
    id: 'best-tip',
    subtitle: "What's your best underrated wedding planning tip?",
    description:
      "You don't have to have a big wedding - invite the people who are most special to you!",
    image: {
      background: {
        type: BackgroundType.IMAGE,
        parameters: {
          alt: 'A white frosted wedding cake with a slice cut out next to a glass of champagne',
          featuredSrc: mobile4,
          jpg: imagesToImageDetails({ mobile: mobile4, tablet: tablet4, desktop: desktop4 }),
        },
      },
    },
  },
];

const AdvisorLpDifferentiation = ({ className }: AdvisorLpDifferentiationProps): JSX.Element => {
  return (
    <Container className={className}>
      <Differentiation content={menuItems} title={titleProps} isPhotoOnRight={false} />
    </Container>
  );
};

export default AdvisorLpDifferentiation;
